import { getApiClient } from "./API";
import { learningServiceRequest, skip } from "./utils";

const classesService = {
  async list(params) {
    const response = await getApiClient().get(`/classes`, { params });
    return response.data;
  },
  async getClassesV3({ limit = "", page = 1, q = "", status = "", source, ...extraParams }) {
    return await learningServiceRequest({
      method: "get",
      url: "/v3/classes",
      params: {
        limit,
        skip: skip(page, limit),
        q,
        status,
        ...extraParams,
      },
      failureMessage: "Error loading Classes data",
      source,
    });
  },
  async getClasses({ limit = "", page = 1, q = "", status = "", source, ...extraParams }) {
    return await learningServiceRequest({
      method: "get",
      url: "/classes",
      params: {
        limit,
        skip: skip(page, limit),
        q,
        status,
        ...extraParams,
      },
      failureMessage: "Error loading Classes data",
      source,
    });
  },
  async getClassById(classId, params = {}) {
    return await learningServiceRequest({
      method: "get",
      url: `/classes/${classId}`,
      params: params,
    });
  },
  async getProgramSessionsByClassId(classId, owner_entity_id = "", get_all = false, page = 1, limit = 10) {
    const skip = (page - 1) * limit;
    return await learningServiceRequest({
      method: "get",
      url: `/classes/${classId}/program-sessions?owner_entity_id=${owner_entity_id}&skip=${skip}&limit=${limit}&get_all=${get_all}`,
      failureMessage: "Error loading related Program Sessions data",
    });
  },
  async getMany({ ids = [], params = {} }) {
    return await learningServiceRequest({
      method: "post",
      url: `/classes/get_many`,
      params,
      payload: { ids: ids },
    });
  },
};

export default classesService;
